import React from "react";
import { Grid, TextField, IconButton, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";


const AddAdditionalFields = ({ nodeData, setNodeData, errors }) => {
    // console.log(errors, "this is for errors");

    const handleAddField = () => {
        const additionalFields = nodeData?.additionalFields;
            

        const data = {
            ...nodeData,
            additionalFields: [
                ...additionalFields,
                { fieldName: "", fieldValue: "" }
            ]
        };

        // console.log(data, "this for data");
        setNodeData(data);  // Update state

        // setNodeData(data);
    };

    const handleRemoveField = (index) => {
        const updatedFields = nodeData?.additionalFields?.filter((_, i) => i !== index);
        setNodeData(prevNodeData => ({
            ...prevNodeData,
            additionalFields: updatedFields
        }));
    };

    const handleFieldChange = (index, field, value) => {
        const updatedFields = nodeData.additionalFields?.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setNodeData({
            ...nodeData,
            additionalFields: updatedFields
        });
    };


    return (
        <Grid container spacing={2}>
            {Array.isArray(nodeData?.additionalFields) && nodeData?.additionalFields?.map((field, index) => (
                <React.Fragment key={index}>
                    <Grid item xs={3}>
                        <TextField
                            label="Field Name"
                            variant="outlined"
                            size="small"
                            value={field.fieldName}
                            onChange={(e) =>
                                handleFieldChange(index, "fieldName", e.target.value)
                            }
                            fullWidth
                            error={Boolean(errors?.additionalFields?.[index]?.fieldName)}
                            helperText={errors?.additionalFields?.[index]?.fieldName}
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            label="Field Value"
                            variant="outlined"
                            size="small"
                            value={field.fieldValue}
                            onChange={(e) =>
                                handleFieldChange(index, "fieldValue", e.target.value)
                            }
                            error={Boolean(errors?.additionalFields?.[index]?.fieldValue)}
                            helperText={errors?.additionalFields?.[index]?.fieldValue}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={1} display="flex" justifyContent={"flex-end"} alignItems="end">
                        <IconButton onClick={() => handleRemoveField(index)} color="error">
                            <DeleteIcon
                                style={{
                                    color: "#1976d2",
                                    cursor: "pointer"
                                }}
                            />
                        </IconButton>
                    </Grid>
                </React.Fragment>
            ))}
            <Grid item xs={12} display="flex" justifyContent="flex-end">
                <Button
                    variant="contained"
                    endIcon={<Add />}
                    onClick={handleAddField}
                >
                    Add Additional Field
                </Button>
            </Grid>
        </Grid>
    );
};

export default AddAdditionalFields;